import type { RawImage } from '../types/Image'

export const imageParser = ({
  alt,
  sizes,
  isModal,
  isGradient,
  imageDarken = false,
}: RawImage) => {
  const src = sizes

  return {
    imageDarken,
    isModal,
    isGradient: Boolean(isGradient),
    image: {
      alt,
      src,
    },
  }
}

export const basicImageParser = ({ alt, sizes }: RawImage) => {
  const src = sizes

  return {
    alt,
    src,
  }
}
